import { SurchargeEventCalculation } from "../../../../shared/models/SurchargeEventCalculation";

const CalculatedEventsItem = (data: SurchargeEventCalculation) => {
  if (data) {
    return (
      <>
        <b>{data.surchargeType}</b> - {data.name}
      </>
    );
  } else {
    return <></>;
  }
};

export default CalculatedEventsItem;
